import React from 'react';

import { InitialConfigType, LexicalComposer } from '@lexical/react/LexicalComposer';

import { EditorSettingsContext } from '../../utils/contexts/EditorSettingsContext';
import { SharedHistoryContext } from '../../utils/contexts/SharedHistoryContext';
import { ToolbarContext } from '../../utils/contexts/ToolbarContext';
import ReadyNodes from './nodes/ReadyNodes';
import EditorTheme from './themes/EditorTheme';

import './main-style.scss';

const defaultConfig: InitialConfigType = {
    editorState: undefined,
    namespace: 'Editor',
    nodes: [...ReadyNodes],
    onError: (error: Error) => {
        console.error('Lexical Editor Error:', error);
        throw error;
    },
    theme: EditorTheme,
};

interface EditorWrapperProps extends React.PropsWithChildren {
    initialConfig?: InitialConfigType;
}

export const EditorWrapper = (props: Readonly<EditorWrapperProps>) => {
    const { children, initialConfig = defaultConfig } = props;

    return (
        <LexicalComposer initialConfig={initialConfig}>
            <EditorSettingsContext>
                <SharedHistoryContext>
                    <ToolbarContext>
                        {children}
                    </ToolbarContext>
                </SharedHistoryContext>
            </EditorSettingsContext>
        </LexicalComposer>
    )
}